var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "newsevents-section" }, [
    (_vm.themes && _vm.themes.length > 0) ||
    (_vm.years && _vm.years.length > 0) ||
    (_vm.provinces && _vm.provinces.length > 0) ||
    (_vm.types && _vm.types.length > 0)
      ? _c("div", { staticClass: "filter-section" }, [
          _c("div", { staticClass: "filter-items" }, [
            _vm.themes && _vm.themes.length > 0
              ? _c("div", { staticClass: "filter-item filter-item--mw" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.theme,
                          expression: "theme",
                        },
                      ],
                      staticClass: "filter-item__select",
                      attrs: { disabled: _vm.isLoading },
                      on: {
                        change: [
                          function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.theme = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                          _vm.filterChanged,
                        ],
                      },
                    },
                    [
                      _c("option", { attrs: { value: "All" } }, [
                        _vm._v(
                          _vm._s(_vm.dictionaries.newsEventsThemeOptionDefault)
                        ),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.themes, function (theme, index) {
                        return theme.name
                          ? _c("option", { domProps: { value: theme.key } }, [
                              _vm._v(
                                _vm._s(theme.name) + "\n                    "
                              ),
                            ])
                          : _vm._e()
                      }),
                    ],
                    2
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types && _vm.types.length > 0
              ? _c("div", { staticClass: "filter-item filter-item--mw" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.type,
                          expression: "type",
                        },
                      ],
                      staticClass: "filter-item__select",
                      attrs: { disabled: _vm.isLoading },
                      on: {
                        change: [
                          function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.type = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                          _vm.filterChanged,
                        ],
                      },
                    },
                    [
                      _c("option", { attrs: { value: "All" } }, [
                        _vm._v(
                          _vm._s(_vm.dictionaries.newsEventsTypeOptionDefault)
                        ),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.types, function (type, index) {
                        return type.name
                          ? _c("option", { domProps: { value: type.key } }, [
                              _vm._v(_vm._s(type.name)),
                            ])
                          : _vm._e()
                      }),
                    ],
                    2
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.years && _vm.years.length > 0
              ? _c("div", { staticClass: "filter-item filter-item--mw" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.year,
                          expression: "year",
                        },
                      ],
                      staticClass: "filter-item__select",
                      attrs: { disabled: _vm.isLoading },
                      on: {
                        change: [
                          function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.year = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                          _vm.filterChanged,
                        ],
                      },
                    },
                    [
                      _c("option", { attrs: { value: "All" } }, [
                        _vm._v(
                          _vm._s(_vm.dictionaries.newsEventsYearOptionDefault)
                        ),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.years, function (year, index) {
                        return year.name
                          ? _c("option", { domProps: { value: year.key } }, [
                              _vm._v(_vm._s(year.name)),
                            ])
                          : _vm._e()
                      }),
                    ],
                    2
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.provinces && _vm.provinces.length > 0
              ? _c("div", { staticClass: "filter-item filter-item--mw" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.province,
                          expression: "province",
                        },
                      ],
                      staticClass: "filter-item__select",
                      attrs: { disabled: _vm.isLoading },
                      on: {
                        change: [
                          function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.province = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                          _vm.filterChanged,
                        ],
                      },
                    },
                    [
                      _c("option", { attrs: { value: "All" } }, [
                        _vm._v(
                          _vm._s(
                            _vm.dictionaries.newsEventsProvinceOptionDefault
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.provinces, function (province, index) {
                        return province.name
                          ? _c(
                              "option",
                              { domProps: { value: province.key } },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(province.name)
                                ),
                              ]
                            )
                          : _vm._e()
                      }),
                    ],
                    2
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "filter-item" }, [
              _c(
                "button",
                {
                  staticClass: "filter-item__button",
                  attrs: { type: "button", disabled: _vm.isLoading },
                  on: { click: _vm.resetFilter },
                },
                [_vm._v(_vm._s(_vm.dictionaries.newsEventsFilterReset))]
              ),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.items.length,
            expression: "items.length",
          },
        ],
        staticClass: "newsevents-items",
      },
      _vm._l(_vm.items, function (newsEventItem) {
        return _c("newsEventItem", {
          key: newsEventItem.id,
          attrs: { newsEventItem: newsEventItem },
        })
      }),
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.items.length && !_vm.isLoading,
            expression: "!items.length && !isLoading",
          },
        ],
        staticClass: "newsevents-items__no-result",
      },
      [_vm._v("\n        " + _vm._s(_vm.dictionaries.newsEventsNoResult))]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.hasMoreProductsToLoad,
            expression: "hasMoreProductsToLoad",
          },
        ],
        staticClass: "newsevents-items__cta",
      },
      [
        _c(
          "a",
          {
            staticClass: "newsevents-items__load-more",
            attrs: { disabled: _vm.isLoading },
            on: { click: _vm.getNextPage },
          },
          [_vm._v(_vm._s(_vm.dictionaries.newsEventsLoadMore))]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }